// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import moment from 'moment'

import {
  validateDateFormat,
  validateDateHasPassed,
  validateDateIsValid,
} from 'validators/common/sync/date'

const validatePastDate = v => {
  const m = moment(v, 'YYYY/MM/DD')
  return (
    validateDateFormat(v) ||
    validateDateIsValid(m) ||
    validateDateHasPassed(m)
  )
}

export default validatePastDate
